import { addLabels, sendCustomError } from '@otto-ec/global-resources/apm'
import { LogLevel } from '../../ports'

export const logApmTransport: {
  [K in LogLevel]: (
    namespaceId: string,
    message?: string | Error,
    labels?: Record<string, string | number | boolean>
  ) => void
} = {
  ERROR: (namespaceId, message?, labels?) => {
    if (!isLoggable(namespaceId, message, labels)) {
      return
    }

    if (message) {
      void sendCustomError(namespaceId, message, labels)
      return
    }
    void sendCustomError(namespaceId, labels!)
  },
  INFO: (namespaceId, message, labels) => {
    if (!isLoggable(namespaceId, message, labels)) {
      return
    }

    const preparedMessage =
      typeof message === 'string'
        ? { message }
        : { message: JSON.stringify(message) }

    const preparedLabels = {
      namespace: namespaceId,
      ...(message ? preparedMessage : {}),
      ...(labels ?? {}),
    }

    void addLabels(preparedLabels)
  },
}

function isLoggable(
  namespaceId: string,
  message?: string | Error,
  labels?: Record<string, string | number | boolean>
): boolean {
  return !!(namespaceId && (message || labels))
}
